<template>
  <div>
    <v-card color="white" class="ma-2">
        <v-card-title class="blue darken-2 white--text">Daftar Rekanan</v-card-title>
        
        <v-card-title>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="search" prepend-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="blacklistFilter"
                :items="blacklistOptions"
                label="Blacklist Filter"
                clearable
                @change="getData"
              />
            </v-col>
          </v-row>
        </v-card-title>
      <v-row class="mt-0 mb-2">
          <v-col cols="10">
          </v-col>
          <v-col cols="2">
              <v-btn color="cyan" dark @click="refreshPage()">Refresh</v-btn>
          </v-col>
      </v-row>

        <v-data-table class="elevation-1" :search="search" :headers="headers" :items="lsVendor" :items-per-page="10" single-select item-key="id" height="400"
            fixed-header :item-class="getRowClass">
            <template v-slot:item.bentuk="{item}">
              {{ bentukCap(item.bentuk) }}
            </template>
            <template v-slot:item.status="{item}">
              {{ statusCap(item.status) }}
            </template>
            <template v-slot:item.actions="{item}">
                <v-btn icon color="cyan" @click="prosesVendor(item.id, item.nama, bentukCap(item.bentuk), item.vendorType)"> <v-icon>mdi-file</v-icon> </v-btn>
            </template>
            <!-- <template v-slot:item.kbli="{item}">            
                <span v-for="kbItem in item.kbli" :key="kbItem" >
                  <v-tooltip top color="yellow lighten-3 black--text">
                    <template v-slot:activator="{ on }">
                      <v-chip
                        class="mr-1 mb-1 subtitle-2"
                        color="teal"
                        label dark
                        v-on="on"
                      > 
                        {{ getKbliKode(kbItem) }}
                      </v-chip>     
                      </template>
                    <span>{{ getKbliTip(kbItem) }}</span>
                  </v-tooltip>                 
                </span>

            </template> -->
        </v-data-table>
    </v-card>

    <v-dialog v-model="isPerson" max-width="1000" persistent>
      <v-card>
        <v-card-title class="green accent-2"> {{ personName }}</v-card-title>
        <VerifikasiPerson v-if="personId" :vendorId="personId" />
        <v-card-actions>
          <v-btn class="blue" @click="isPerson = false" dark>Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Verifikasi></Verifikasi>
    
  </div>
</template>

<script>
import axios from 'axios'
const apiUrl = process.env.VUE_APP_ROOT_API
import { itemsBentukUsaha, statusVendor } from './../../lib/viewLib'
import { evBus } from '@/main'

//components
import Verifikasi from './../../components/user/Verifikasi'
import VerifikasiPerson from "./../../components/user/VerifikasiPerson"


export default {
  name: 'UserHome',
  components: { Verifikasi, VerifikasiPerson },
  data: function() {
    return {
      // Data table
      search: "",
      headers: 
      [
          { text: "Nama Perusahaan", value: "nama", class: "yellow lighten-3 subtitle-2" },
          { text: "No. Registrasi", value: "noRegistrasi", class: "yellow lighten-3 subtitle-2" },
          { text: "Bentuk", value: "bentuk", class: "yellow lighten-3 subtitle-2" },
          { text: "KBLI", value: "kbli_kode_string", class: "yellow lighten-3 subtitle-2" },
          // { text: "Alamat", value: "alamat", class: "yellow lighten-3 subtitle-2" },
          { text: "Status", value: "status", class: "yellow lighten-3 subtitle-2" },
          { text: "", value: "actions", sortable: false, class: "yellow lighten-3 subtitle-2" }
      ],
      listKBLI: [],
      lsVendor: [],
      isPerson: false,
      personId: null,
      personName: "",
      showKbliKodeString: true,
      blacklistOptions: [
        { text: "All", value: null },
        { text: "Blacklisted", value: 1 },
        { text: "Not Blacklisted", value: 0 }
      ],
      blacklistFilter: null,
    }
  },
  methods: {
    bentukCap: bentuk => itemsBentukUsaha.find(el => el.value === bentuk).text,
    statusCap: status => statusVendor.find(el => el.status === status).caption,
    prosesVendor: function(id, nama, bentuk, type) {
      this.$store.commit('ven/setId', id)
      this.$store.commit('ven/setName', nama)

      if (type === 'O') {
        this.isPerson = true;
        this.personId = id;
        this.personName = nama;
      }
      else {
        this.isPerson = false;
        this.personId = null;
        this.personName = "";
        evBus.$emit('dlgVerifikasi', { id: id, nama: nama, bentuk: bentuk })
      }
    },
    // Table Preformat Data
    getKbliKode: function(id) {
      console.log("Get KBLI kode: ", id);
      const found = this.listKBLI.find(element => element.id == id);
      return found ? found.kode : '';
    },
    getKbliTip: function(id) {
      console.log("Get KBLI tip: ", id);
      const found = this.listKBLI.find(element => element.id == id);
      return found ? found.nama : '-';
    },
    getRowClass(item) {
      return item.blacklist ? 'black-row' : '';
    },
    async getData() {
      this.lsVendor = [];
      await axios.get(`${apiUrl}/vendor/verified/${this.blacklistFilter}`)
        .then((response) => {
          response.data.forEach(element => {
          element.kbli_id = element.kbli;
          element.kbli_kode_string = "";
          if(element.kbli_id) {
            let tmpkode = element.kbli.split(',')
            let tmpkbli = []
            let kbli_kode_string = "";
            tmpkode.forEach(val => {
              kbli_kode_string += this.getKbliKode(val)+',';
              tmpkbli.push(Number(val));
            })
            element.kbli = tmpkbli;
            element.kbli_kode_string = kbli_kode_string;
          }
          this.lsVendor.push(element);
        })   
        })
        .catch((error) => {
          console.error(error)
        })
    }, 
    refreshPage() {
        this.$router.push({ name: 'TemporaryPage', params: { link: '/admin/vendor/verified'} }); 
    },   
  },
  created: async function() {
    
    await axios.get(`${apiUrl}/kbli`)
    .then( (response) => {
      this.listKBLI = response.data;
    });

    await this.getData();
  }
}
</script>

<style>
.black-row {
  background-color: rgba(0, 0, 0, 0.801) !important;
  color: white !important;
}
</style>
